import page from 'page';

export default function RouterProvider() {
  return {
    goTo(url: string): void {
      page(url);
    },
  };
}
